import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from 'vue';
  
  interface Props {
    modelValue: boolean;
    clientId: string;
  }
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ClientAddedModal',
  props: {
    modelValue: { type: Boolean },
    clientId: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

  const props = __props;
  const emit = __emit;
  
  const showCopiedAlert = ref(false);
  
  const generatedUrl = computed(() => {
    const baseUrl = process.env.VUE_APP_LANDING_PAGE_URL;
    console.log(baseUrl);
    return `${baseUrl}${props.clientId}`;
  });
  
  const copyUrl = async () => {
    try {
      await navigator.clipboard.writeText(generatedUrl.value);
      showCopiedAlert.value = true;
      setTimeout(() => {
        showCopiedAlert.value = false;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy URL:', err);
    }
  };
  
return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    "max-width": "900px"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createTextVNode("Client URL Generated")
            ])),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-4" }, "Share this URL with your client:", -1)),
              _createVNode(_component_v_text_field, {
                "model-value": generatedUrl.value,
                readonly: "",
                variant: "outlined",
                "append-inner-icon": "mdi-content-copy",
                "onClick:appendInner": copyUrl
              }, null, 8, ["model-value"]),
              (showCopiedAlert.value)
                ? (_openBlock(), _createBlock(_component_v_alert, {
                    key: 0,
                    color: "success",
                    variant: "tonal",
                    class: "mt-2"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode(" URL copied to clipboard! ")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "text",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', false)))
              }, {
                default: _withCtx(() => _cache[5] || (_cache[5] = [
                  _createTextVNode(" Close ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})